<script setup>
import {computed} from 'vue'
import SiteTreeContentItem from './SiteTreeContentItem'
import {usePageContentDataStore} from '@/stores/pageContentData'

const props = defineProps({
    siteTreeId: String,
    pageId: Number,
    contentArea: String
})

const pageContentDataStore = usePageContentDataStore()

const contentIds = computed(() => {
    return (pageContentDataStore.items || [])
        .filter(o => o.pageId === props.pageId && o.contentArea === props.contentArea)
        .map(o => o.id)
})
</script>

<template>
    <div v-show="contentIds.length">
        <div class="p-1 px-2 small fw-bold text-body-secondary">
            <span class="small">{{ contentArea }}</span>
        </div>

        <div class="list-group">
            <SiteTreeContentItem v-for="contentId in contentIds" :key="contentId" :site-tree-id="siteTreeId"
                                 :page-content-id="contentId"/>
        </div>
    </div>
</template>